import { getValueFromCMSTextObject, interpolateText, retrieveCMSTextFromDeepObject } from './utils';

export const BASE_GROUP = 'application_form';

export default {
  /**
   * Returns a function that gets text from the state given a key and context.
   *
   * @param {Object} state - The module's state
   * @param {Object} getters - An object with the module's getters
   * @return {function(string, Object, string, number): string} A function that gets the requested key
   *                                                    processed with the given context.
   */
  getCMSText(state, getters) {
    return (key, context, defaultValue, categoryId) => {
      const text = getters.getNestedCMSText(key, defaultValue, categoryId);
      return interpolateText(text, context);
    };
  },

  /**
   * Get CMS text that's nested
   *
   * @param {Object} state - The module's state
   * @return {string} The value or an empty string
   */
  getNestedCMSText(state) {
    return (key, defaultValue, categoryId) => {
      const baseGroup = state.text[BASE_GROUP];
      const cmsTextObject = retrieveCMSTextFromDeepObject(baseGroup, key.split(':'));
      return getValueFromCMSTextObject(cmsTextObject, defaultValue, categoryId);
    };
  },
};
